<style lang="less" scoped>
  .abs-center { position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); }
  .abs-tcenter { position: absolute; top: 50%; transform: translate(0,-50%); }
  .abs-lcenter { position: absolute; left: 50%; transform: translate(-50%,0); }

  nav {
    overflow: hidden; max-width: 1200px;
    margin: 0 auto;
    h1 {
      float: left;
      margin: 40px 0 0 0px;
      width: 173px; height: 60px; background: url(~@/assets/logo-1.png) no-repeat;
      font-size: 0; color: transparent;
    }
    ul {
      &.mobile { display: none; }
      float: right;
      width: 550px; padding-top: 40px;
      li {
        float: left;
        a {
          font-size: 19px; color: #fff; cursor: pointer;
          display: block; text-align: center; padding: 20px;
          &.blue {
            color: #51bbff;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 1200px) {
    .main-container {
      background: url(~@/assets/bg-1.png) no-repeat -409px top;
    }
  }
  @media only screen and (max-width: 768px) {
    .main-container {
      overflow: hidden; width: 100%;
      background: url(~@/assets/m-bg-1.png) no-repeat right top;
      background-size: 306px 144px;
    }
    nav {
      h1 {
        width: 86px; height: 30px;
        background-size: cover; margin: 21px 0 0 10px;
      }
      ul {
        display: none; width: auto; padding-top: 23px;
        &.mobile { display: block; }
        li {
          a {
            font-size: 14px; padding: 12px; color: #51bbff;
          }
        }
      }
    }
  }
</style>

<template lang="pug">
  .main-container
    nav.nav
      h1 blue mobile
      ul
        li
          a(v-scroll-to="'#ohnaebus'") 오네버스
        li
          a(v-scroll-to="'#ulivebus'") ULiveBUS
        li
          a(v-scroll-to="'#subway'") 지하철팝
        li
          a.blue(v-scroll-to="'#history'") 연혁
        li
          a.blue(v-scroll-to="'#aboutus'") About Us
      ul.mobile
        li
          a(v-scroll-to="'#solution'") Solution
        li
          a.blue(v-scroll-to="'#history'") History
        li
          a.blue(v-scroll-to="'#aboutus'") About Us
    intro
    solution(id="solution")
    ohnaebus(v-if="ohnaebus !== null", id="ohnaebus", :ohnaebus="ohnaebus")
    ulivebus(v-if="ulivebus !== null", id="ulivebus", :ulivebus="ulivebus")
    subway(v-if="subway !== null", id="subway", :subway="subway")
    history(v-if="histories !== null", id="history", :histories="histories")
    partner(v-if="partners !== null", :partners="partners")
    aboutus(id="aboutus")
</template>

<script>
import Intro from '@/components/Intro.vue';
import Solution from '@/components/Solution.vue';
import Ohnaebus from '@/components/Ohnaebus.vue';
import Ulivebus from '@/components/Ulivebus.vue';
import Subway from '@/components/Subway.vue';
import History from '@/components/History.vue';
import Partner from '@/components/Partner.vue';
import Aboutus from '@/components/Aboutus.vue';

export default {
  components: {
    Intro,
    Solution,
    Ohnaebus,
    Ulivebus,
    Subway,
    History,
    Partner,
    Aboutus,
  },
  computed: {
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      };
    },
  },
  async mounted() {
    const { data } = await this.$http.get('/static/ajax.json');
    this.ohnaebus = data.ohnaebus;
    this.ulivebus = data.ulivebus;
    this.subway = data.subway;
    this.histories = data.histories;
    this.partners = data.partners;
  },
  data() {
    return {
      ohnaebus: null,
      ulivebus: null,
      subway: null,
      histories: null,
      partners: null,
    };
  },
};
</script>
